(function(){
    function getProductJson(){
      var scripts=document.querySelectorAll('script[id^="ProductJson-"]');
      for(var i=0;i<scripts.length;i++){
        try{return JSON.parse(scripts[i].textContent);}catch(e){}
      }
      return null;
    }
    function getVariantId(){
      try{return new URL(window.location.href).searchParams.get("variant");}
      catch(e){return null;}
    }
    function findBarcode(p,vid){
      if(!p||!p.variants)return "";
      var fb="";
      for(var i=0;i<p.variants.length;i++){
        var v=p.variants[i];
        if(vid&&String(v.id)===String(vid))return v.barcode||v.sku||"";
        if(i===0)fb=v.barcode||v.sku||"";
      }
      return fb;
    }
    function paint(L,stores){
      if(!stores||!stores.length){
        L.innerHTML='<div style="color:#999;font-size:13px">No disponible.</div>';
        return;
      }
      var html="";
      for(var i=0;i<stores.length;i++){
        var s=stores[i];
        var ok=s.status!="out";
        var dot=ok?"#1a8a3a":"#c44";
        var lbl=ok?"Disponible":"No disponible";
        var op=ok?"1":"0.5";
        html+='<div style="display:flex;align-items:center;gap:10px;padding:4px 0;opacity:'+op+'">';
        html+='<span style="width:10px;height:10px;border-radius:50%;background:'+dot+'"></span>';
        html+='<div><div style="font-size:13px;font-weight:600;color:#1a1a1a">'+s.name+'</div>';
        html+='<div style="font-size:11px;color:#888">'+lbl+'</div></div></div>';
      }
      L.innerHTML=html;
    }
    function loadStock(bc){
      var r=document.getElementById("zfr-stock");
      if(!r)return;
      var L=document.getElementById("zfr-list");
      if(!L)return;
      var ep=r.getAttribute("data-ep");
      if(!bc){
        L.innerHTML='<div style="color:#999;font-size:13px">Sin codigo.</div>';
        return;
      }
      L.innerHTML='<div style="color:#999;font-size:13px">Verificando...</div>';
      fetch(ep+"?barcode="+encodeURIComponent(bc))
        .then(function(x){return x.json();})
        .then(function(d){paint(L,d&&d.matched?d.stores:null);})
        .catch(function(){
          L.innerHTML='<div style="color:#c44;font-size:13px">Error.</div>';
        });
    }
    function refresh(){
      var p=getProductJson();
      var vid=getVariantId();
      var bc=findBarcode(p,vid);
      loadStock(bc);
    }
    refresh();
    var lastUrl=window.location.href;
    setInterval(function(){
      if(window.location.href!==lastUrl){
        lastUrl=window.location.href;
        refresh();
      }
    },300);
    document.addEventListener("change",function(ev){
      if(ev.target&&(ev.target.name==="id"||ev.target.matches('input[type="radio"]')||ev.target.matches("select"))){
        setTimeout(refresh,100);
      }
    });
  })();